var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import Stack from "../Stack/index.js";
import Icon from "../Icon/index.js";
import Button from "../Button/index.js";
import Text from "../Text/index.js";
import styles from "@bookingcom/bui-core/css/EmptyState.module.css";
var EmptyState = function (props) {
    var icon = props.icon, title = props.title, text = props.text, button = props.button, link = props.link, topIllustration = props.topIllustration, startIllustration = props.startIllustration, className = props.className, attributes = props.attributes, mixin = props.mixin;
    var topSlot = topIllustration;
    var horizontal = !!startIllustration;
    var rootClassName = classNames(styles.root, className, horizontal && styles["root--horizontal"], mixinClassNames(mixin));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    return (React.createElement("div", __assign({}, rootAttributes, { className: rootClassName }),
        startIllustration && (React.createElement("div", { className: styles.startSlot }, startIllustration)),
        React.createElement(Stack, { gap: 6, alignItems: "center", className: styles.content },
            icon && React.createElement(Icon, { svg: icon, size: "largest", className: styles.icon }),
            topSlot && React.createElement("div", { className: styles.slot }, topSlot),
            React.createElement(Stack.Item, null,
                title && (React.createElement(Text, { className: styles.title, tagName: "h3", variant: "headline_2" }, title)),
                React.createElement(Text, { className: styles.text, tagName: "p", variant: "body_1" }, text)),
            React.createElement("div", { className: styles.actions },
                button && (React.createElement(Button, __assign({}, button, { size: "large", wide: false, variant: "primary" }))),
                link && (React.createElement(Button, __assign({}, link, { size: "large", wide: false, variant: "tertiary", className: styles.link })))))));
};
export default EmptyState;
